import React from 'react';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Tooltip component that wraps Bootstrap OverlayTrigger and Tooltip
 * Provides consistent tooltip behavior across the application
 */
const Tooltip = ({
  children,
  text,
  placement = 'top',
  delay = 0,
  id,
  disabled = false,
  ...props
}) => {
  if (disabled || !text) {
    return children;
  }

  const tooltipId = id || `tooltip-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: delay, hide: 0 }}
      overlay={
        <BootstrapTooltip id={tooltipId}>
          {text}
        </BootstrapTooltip>
      }
      {...props}
    >
      {children}
    </OverlayTrigger>
  );
};

Tooltip.propTypes = {
  /** Element that will trigger the tooltip */
  children: PropTypes.node.isRequired,
  /** Text to display in the tooltip */
  text: PropTypes.node.isRequired,
  /** Position of the tooltip */
  placement: PropTypes.oneOf([
    'auto-start', 'auto', 'auto-end',
    'top-start', 'top', 'top-end',
    'right-start', 'right', 'right-end',
    'bottom-start', 'bottom', 'bottom-end',
    'left-start', 'left', 'left-end'
  ]),
  /** Delay in ms before showing tooltip */
  delay: PropTypes.number,
  /** Custom ID for the tooltip */
  id: PropTypes.string,
  /** Whether to disable the tooltip */
  disabled: PropTypes.bool
};

export default Tooltip;